import { render, staticRenderFns } from "./#detail-export.vue?vue&type=template&id=36d6a58e&"
import script from "./#detail-export.vue?vue&type=script&lang=js&"
export * from "./#detail-export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports